<template>
  <section class="ts-detail-view-section">
    <div v-if="!isLoading && detailData && this.listSubMenu">
      <base-info-bar>
        <router-link to="/training-services/pilot-training">{{ getMenuInfo.name }}</router-link>
        <span><img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png">
          >
          <img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png"></span>
        <router-link :to="getSubMenuInfo.url">{{ getSubMenuInfo.name }}</router-link>
        <span><img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png">
          >
          <img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png"></span>
        <router-link :to="detailData.url" style="color: black;">{{ detailData.name }}</router-link>
      </base-info-bar>
      <TrainingServicesDetail :entry="getSubMenuInfo.name" :title="detailData.name"
        :content="detailData.description"></TrainingServicesDetail>
    </div>
  </section>
</template>

<script>
import TrainingServicesDetail from '@/components/training-services/TrainingServicesDetail.vue'
export default {
  props: ['url'],
  components: {
    TrainingServicesDetail
  },
  data () {
    return {
      isLoading: false,
      listSubMenu: [],
      subMenuId: null
      // detailData: null
    }
  },
  computed: {
    getMenuInfo () {
      return this.$store.getters['navbar/finalMenu'][2]
    },
    getSubMenuInfo () {
      return this.$store.getters['navbar/findSubMenus1'](this.subMenuId)
    },
    detailData () {
      return this.$store.getters['services/getDescriptionForTS']
    }
    // getSubMenuInfo () {
    //   return this.$store.getters['navbar/findSubMenus1'](this.subMenusDetails[1])
    // },
    // subMenusDetails () {
    //   return this.$store.getters['services/findSubMenusDetails'](this.url)
    // }
  },
  watch: { // Change the subMenuId by the lang when detailData change in the getter of services
    detailData (newValue) {
      if (newValue && this.$store.state.lang === 'vn') this.subMenuId = this.listSubMenu[0]
      else this.subMenuId = this.listSubMenu[1]
    }
  },
  async created () {
    this.isLoading = true
    const ts = await this.$store.dispatch('services/getTSDetailByUrl', this.url) // Search in TSDetail for the url
    if (ts) {
      // If it in TSDetail
      this.listSubMenu = await this.$store.dispatch('services/getTSSubMenuId', { id: ts[0] }) // get subMenuId from TS then set this.subMenuId by the lang
      if (this.listSubMenu) {
        if (this.$store.state.lang === 'vn') this.subMenuId = this.listSubMenu[0]
        else this.subMenuId = this.listSubMenu[1]
      }
    } else {
      // If it not
      this.listSubMenu = await this.$store.dispatch('services/getTSByUrl', this.url) // Search in TS for the url then set this.subMenuId by the lang
      if (this.listSubMenu) {
        if (this.$store.state.lang === 'vn') this.subMenuId = this.listSubMenu[0]
        else this.subMenuId = this.listSubMenu[1]
      }
    }
    this.isLoading = false
  }
}
</script>

<style scoped>
.ts-detail-view-section a {
  text-decoration: none;
  color: rgb(28, 108, 193);
  font-weight: 700;
}

.ts-detail-view-section span{
  font-weight: 800;
}
</style>
